<div class="drw-container">
  <div class="drw-header">
    <span class="drw-title">Submit Request</span>
    <button (click)="close()" mat-icon-button [disabled]="isSubmitting">
      <mat-icon class="drw-close" viewBox="0 0 24 24" fill="none">close</mat-icon>
    </button>
  </div>

  <div class="drw-content">
    <div class="drw-sub-content">
      <span class="drw-title">Request Information</span>

      <form [formGroup]="submitForm" class="submit-form">
        <!-- Transaction Amount -->
        <label for="amount">Request Amount</label>
        <mat-form-field appearance="fill" class="full-width">
          <span matPrefix>&nbsp;$</span>
          <input matInput formControlName="amount" id="amount" placeholder="Amount" type="text" mask="separator.2" [thousandSeparator]="','">
          @if (submitForm.get('amount')?.hasError('required')) {
            <mat-error>
              Request amount is required
            </mat-error>
          }
          @if (submitForm.get('amount')?.hasError('min')) {
            <mat-error>
              Amount must be at least $0.01
            </mat-error>
          }
          @if (submitForm.get('amount')?.hasError('max')) {
            <mat-error>
              Amount must be less than borrower's remaining balance of
              {{ data.customer.availableBalance | currency }}
            </mat-error>
          }
          @if (submitForm.get('amount')?.hasError('pattern')) {
            <mat-error>
              Please enter a valid amount (up to 2 decimal places)
            </mat-error>
          }
        </mat-form-field>

        <!-- Purchase Order Number -->
        <label for="ponumber">Purchase Order Number</label>
        <mat-form-field appearance="fill" class="full-width">
          <input matInput formControlName="ponumber" id="ponumber" placeholder="Order Number">
          @if (submitForm.get('ponumber')?.hasError('required')) {
            <mat-error>
              Purchase order number is required
            </mat-error>
          }
        </mat-form-field>

        <!-- Invoice Number -->
        <label for="inumber">Invoice Number (optional)</label>
        <mat-form-field appearance="fill" class="full-width">
          <input matInput formControlName="inumber" id="inumber" placeholder="Invoice Number">
        </mat-form-field>

        <!-- File Upload -->
        <div class="file-upload-section">
          <label>Attach Invoice</label>
          <input type="file" multiple accept=".pdf,.jpeg,.jpg,.png" (change)="onFileChange($event)"
            #fileInput>
            <button type="button" mat-raised-button (click)="fileInput.click()">
              Choose Files
            </button>

            <!-- File validation errors -->
            @if (submitForm.get('invoice')?.hasError('format')) {
              <mat-error>
                Only PDF, JPEG, and PNG files are allowed.
              </mat-error>
            }
            @if (submitForm.get('invoice')?.hasError('size')) {
              <mat-error>
                File size should be less than 5MB.
              </mat-error>
            }

            <!-- Uploaded files list -->
            @if (uploadedFiles.length > 0) {
              <div class="uploaded-files">
                @for (file of uploadedFiles; track file; let i = $index) {
                  <div class="file-item">
                    <span>{{ file.name }}</span>
                    <button type="button" mat-icon-button (click)="removeFile(i)">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                }
              </div>
            }
          </div>

          <!-- Payment Plan -->
          <label for="planId">Payment Plan</label>
          <mat-form-field appearance="fill" class="full-width">
            <mat-select formControlName="planId" placeholder="Choose Payment Plan" id="planId">
              @for (plan of creditPlans; track plan) {
                <mat-option [value]="plan.id">
                  {{ plan.name }}
                </mat-option>
              }
            </mat-select>
            @if (submitForm.get('planId')?.hasError('required')) {
              <mat-error>
                Payment plan is required
              </mat-error>
            }
            @if (creditPlans.length === 0 && !isLoadingCreditPlans) {
              <mat-hint>
                No plans available. Please contact us at support&#64;transendfinancial.com or 833-378-3841
              </mat-hint>
            }
          </mat-form-field>

          <!-- Memo -->
          <label for="memo">Memo (optional)</label>
          <mat-form-field appearance="fill" class="full-width">
            <textarea matInput formControlName="memo" placeholder="Optional memo" rows="3" id="memo"></textarea>
          </mat-form-field>
        </form>
      </div>
    </div>

    <div class="drw-footer">
      <button class="dialog-submit" mat-flat-button color="accent" [disabled]="submitForm.invalid || isSubmitting"
        (click)="submit()">
        @if (isSubmitting) {
          <mat-spinner [diameter]="20" color="accent"></mat-spinner>
        }
        @if (!isSubmitting) {
          <span>Submit Request</span>
        }
      </button>
    </div>
  </div>
